<template>
  <span
    @click="handleClick(item)"
    :class="cssClass"
    :style="locationItemStyle"
  >{{ item.name }}</span>
</template>

<script>
export default {
  name: "DropDownItem",
  props: {
    item: {
      type: Object,
    },
    active: {
      type: Boolean,
    },
    darkBg: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    cssClass() {
      const activeClass = this.active ? " active" : ""
      const colorClass = this.darkBg ? " light-theme" : ""
      return `dropdown-item${colorClass}${activeClass}`
    },
    locationItemStyle() {
      // if item is location, indent location children
      if (!this.item.depth) return null

      return this.item.depth > 1
        ? { "padding-left": this.item.depth + 1 + ".75em" }
        : null
    },
  },
  methods: {
    handleClick(item) {
      const newItem = this.item

      newItem.active = !item.active
      this.$emit("handle-item-click", newItem)
    },
  },
}
</script>

<style scoped>
.dropdown-item {
  color: #007bff;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
.light-theme {
  color: rgb(255, 255, 255);
}
</style>
